module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_pp1_8003.64628e1e.png";